import { Menu, MenuButton, MenuItem, MenuList, Portal as PortalBody } from '@chakra-ui/react';
import {
  ArrowDownTwoIcon,
  BoardIcon,
  ChevronDownIcon,
  CloseIcon,
  DocumentIcon,
  DownArrowIcon,
  DropDownIcon,
  EmbedViewIcon,
  MoreIcon,
  WhiteBoardIcon,
  WorksheetIcon,
} from '@sketchnote/icons';
import { CheckboxKanbanItem, MoreActionMenuProps } from '@sketchnote/shared-components';
import cn from 'classnames';
import { objectTraps } from 'immer/dist/internal';
import * as React from 'react';
const { useState, useCallback, Fragment, useEffect } = React;

const iconList = {
  document: <DocumentIcon wrapperClass={'mt-1'} />,
  whiteboard: <WhiteBoardIcon wrapperClass={'mt-2'} />,
  task: <BoardIcon className={'mt-1'} />,
  embed: <EmbedViewIcon className={'mt-4'} />,
  sheet: <WorksheetIcon className={'mt-1'} />,
};

export const ShowSelected = ({ title, subTitle }: { title: string; subTitle?: string }) => (
  <div className="w-auto">
    <p>{title}</p>
    <p className="text-gray-500 font-regular">{subTitle}</p>
  </div>
);

interface DropdownCheckboxProps extends MoreActionMenuProps {
  selectedItems?: any;
  showSelectedItemCount?: boolean;
  buttonCountText?: string;
  onChangeMenuItem?: any;
  totalItems?: number;
}
export const DropdownCheckbox = ({
  menuItems,
  selectedItems = [],
  totalItems = 0,
  onClickMenuItem,
  icon = <DownArrowIcon />,
  headerData,
  onOpenMenu,
  onCloseMenu,
  classNames,
  showSelectedItemCount = true,
  placement,
  buttonCountText = 'views',
  disabled = false,
  usePortal = false,
  onChangeMenuItem,
}: DropdownCheckboxProps) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [currentSelectedOptions, setCurrentSelectedOptions] = useState<any>([]);
  // const [menuOptions, setMenuOptions] = useState<any>([]);

  useEffect(() => {
    setCurrentSelectedOptions(selectedItems);
  }, [selectedItems]);

  const handleMenuOpen = () => {
    onOpenMenu?.();
    setIsMenuOpened(true);
  };
  const handleMenuClose = () => {
    onCloseMenu?.();
    setIsMenuOpened(false);
  };
  const handlePropagation: React.MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
    e.stopPropagation();
  }, []);

  const handleSelectOption = (obj) => {
    const tempOption = [...currentSelectedOptions];

    const ind = tempOption.findIndex((item) => item.value === obj.value);
    if (ind == -1) {
      tempOption.push({ ...obj });
    } else {
      tempOption.splice(ind, 1);
    }

    onChangeMenuItem([...tempOption]);
    setCurrentSelectedOptions([...tempOption]);
  };

  const handleSelectAll = () => {
    if (currentSelectedOptions.length !== menuItems.length) {
      onChangeMenuItem([...menuItems]);
      setCurrentSelectedOptions([...menuItems]);
    } else {
      onChangeMenuItem([]);
      setCurrentSelectedOptions([]);
    }
  };
  const Portal = usePortal ? PortalBody : React.Fragment;

  return (
    <Menu
      onClose={handleMenuClose}
      onOpen={handleMenuOpen}
      placement={placement}
      isLazy
      modifiers={[{ name: 'eventListeners', options: { scroll: isMenuOpened } }]}
    >
      <MenuButton disabled={disabled} className="inline-block">
        <div className="flex text-gray-500 text-sm ">
          {showSelectedItemCount && (
            <span>
              {currentSelectedOptions.length && totalItems !== currentSelectedOptions.length
                ? `${currentSelectedOptions.length} ${buttonCountText} `
                : 'All views'}
            </span>
          )}
          <span className="inline-block mt-3 text-sm text-gray-500">
            &nbsp;
            {icon}
          </span>
        </div>
      </MenuButton>

      <Portal>
        <div className="more-menu-popover">
          <MenuList className="bg-white min-w-160 p-6 flex-col inline-flex shadow-sm rounded-md w-full">
            <div className="max-h-300 scrolling-auto overflow-auto">
              <div
                onClick={handleSelectAll}
                className="flex gap-8 px-10 h-40 items-center hover:bg-gray-100 min-w-200"
              >
                <CheckboxKanbanItem
                  onChange={handleSelectAll}
                  size="small"
                  color="#254DDA"
                  checked={currentSelectedOptions.length === menuItems.length}
                />
                <p
                  className={`text-sm  font-medium ${
                    currentSelectedOptions.length === menuItems.length
                      ? 'text-primary-500'
                      : 'text-gray-500'
                  }  leading-20`}
                >
                  All views
                </p>
              </div>
              <hr className="bg-gray-200 h-1" />
              {menuItems?.map((item: any, index) => (
                <div
                  key={`${item.label}-${index}`}
                  className={`flex gap-8 px-10 h-40  items-center hover:bg-gray-100 min-w-200 ${
                    currentSelectedOptions.some((obj) => item.value === obj.value)
                      ? 'text-primary-500'
                      : 'text-gray-500'
                  }`}
                  onClick={() => handleSelectOption(item)}
                >
                  <CheckboxKanbanItem
                    onChange={() => handleSelectOption(item)}
                    checked={currentSelectedOptions.some((obj) => item.value === obj.value)}
                    size="small"
                    color="#254DDA"
                  />
                  {item.view && iconList[item.view]}
                  <p className={`text-sm font-medium leading-20 `}>
                    {item.label[0].toUpperCase() + item.label.slice(1)}
                  </p>
                </div>
              ))}
            </div>
          </MenuList>
        </div>
      </Portal>
    </Menu>
  );
};
